// @flow
import type { API, Guide, State } from './interfaces';

export const api = (): void | API => undefined;
export const guide = (): void | Guide => undefined;
export const version = (): string => 'latest';

export const index = (): Object => ({
  api: {},
  guide: {},
});

export const state = (): State => ({
  api: api(),
  string: version(),
  index: index(),
  guide: guide()
});



// WEBPACK FOOTER //
// ./src/reducers/version/defaultValues.js